import { render } from "./EmployeeWorkspace.vue?vue&type=template&id=494594b6&scoped=true"
import script from "./EmployeeWorkspace.vue?vue&type=script&lang=js"
export * from "./EmployeeWorkspace.vue?vue&type=script&lang=js"

import "./EmployeeWorkspace.vue?vue&type=style&index=0&id=494594b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-494594b6"]])

export default __exports__